<template>
  <form>
    <div class="mb-4">
      <label
        for="course"
        class="form-label"
      >
        {{ t('contact_faq.course') }}
      </label>
      <base-form-select class="mb-1" v-model:selectedVal="contact_course_id" :options="store.state.contact.course" />
    </div>
    <div class="mb-4">
      <label
        for="category"
        class="form-label"
      >
        {{ t('word.contents') }}
      </label>
      <base-form-select class="mb-1" v-model:selectedVal="contact_category_id" :options="store.state.contact.category" />
    </div>
    <div class="mb-4">
      <label
        for="subject"
        class="form-label"
      >
        {{ t('word.subject') }}
      </label>
      <input
        v-model="subject"
        id="subject"
        name="subject"
        type="text"
        :placeholder="t('word.subject')"
        :class="`form-input mb-1 ${errors['subject'] ? 'border-red-500' : ''}`"
      >
      <p class="form-error-text">{{ errors['subject'] }}</p>
    </div>
    <div class="mb-4">
      <label
        for="body"
        class="form-label"
      >
        {{ t('word.body') }}
      </label>
      <textarea
        v-model="body"
        id="body"
        name="body"
        :placeholder="t('word.body')"
        :class="`form-input mb-1 ${errors['body'] ? 'border-red-500' : ''}`"
        :rows="5"
      ></textarea>
      <p class="form-error-text">{{ errors['body'] }}</p>
    </div>
    <div class="pt-4 pb-2 flex justify-end">
      <button type="button" class="bg-blue-500 hover:bg-blue-400 text-white py-1.5 px-4 rounded disabled:opacity-75 mr-2" @click="onContactConfirm()">確認</button>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import BaseFormSelect from '@/components/BaseFormSelect.vue'

export default defineComponent({
  components: { BaseFormSelect },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const initialValues = {
      contact_category_id: store.state.contact.contact.contact_category_id ?? 1,
      contact_course_id: store.state.contact.contact.contact_course_id ?? 1,
      subject: store.state.contact.contact.subject ?? '',
      body: store.state.contact.contact.body ?? '',
    }

    const schema = yup.object({
      contact_category_id: yup.number().required(),
      contact_course_id: yup.number().required(),
      subject: yup.string().required().max(255),
      body: yup.string().required().max(5000),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: contact_category_id } = useField<number>('contact_category_id')
    const { value: contact_course_id } = useField<number>('contact_course_id')
    const { value: subject } = useField<string>('subject')
    const { value: body } = useField<string>('body')

    const onContactConfirm = handleSubmit(values => {
      store.commit('contact/setcontact_category_id', values.contact_category_id)
      store.commit('contact/setcontact_course_id', values.contact_course_id)
      store.commit('contact/setSubject', values.subject)
      store.commit('contact/setBody', values.body)
      store.dispatch('contact/contactConfirmOn')
    })

    const selectCategory = () => {
      return Array.isArray(store.state.contact.category) ? store.state.contact.category.find(category => category.value === contact_category_id.value)?.text : ''
    }

    return {
      t,
      errors,
      contact_category_id,
      contact_course_id,
      subject,
      body,
      onContactConfirm,
      store,
      selectCategory
    }
  },
})
</script>
